import { useEffect } from "react";

export const useViewHotkeys = (go) => {
  useEffect(() => {
    const onKey = (e) => {
      const k = e.key.toLowerCase();
      // if (k === "0" || k === "a") return go("all");
      // if (k === "1") return go("hero");
      // if (k === "2") return go("podium");
      // if (k === "3") return go("standings");
      // if (k === "4") return go("brands");
      // if (k === "5") return go("partners");
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [go]);
};
